// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__tcYPp","content":"LayoutSettings_content__2sdmz"};